import { StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { useSelector } from "react-redux";
import { getFlagTableRows, getDisplayInvolvements } from "./flagUtils";

const flagWarrantsDetailsHeaders = [
  { key: "flag", text: "Flag" },
  { key: "summaryDescription", text: "Summary Description" },
  { key: "relatedRecordSummary", text: "Related Record Summary" },
];

const FlagWarrantsDetails = () => {
  const bookings = useSelector((state) => state?.bookings?.bookings);
  const jacketFlags = useSelector((state) => state?.bookings?.jacketFlags);
  const rows = getFlagTableRows(
    getDisplayInvolvements(bookings, jacketFlags),
    "FLAGTYPES_WARRANTS",
    "Warrants",
    bookings,
  );

  return (
    <>
      <StyledGridRow justify={"space-between"}>
        <StyledGridCol></StyledGridCol>
        <StyledGridCol>
          <Button>Delete</Button>
        </StyledGridCol>
      </StyledGridRow>

      <Table headers={flagWarrantsDetailsHeaders} data={rows} style={{ marginTop: "15px" }} />
    </>
  );
};
export default FlagWarrantsDetails;
